<div class="fx-column" #captions>
  @for (u of chunks; track $index) {
  <app-caption-item class="caption-item" [chunk]="u">
    {{ u.transcript }}
  </app-caption-item>
  }
</div>
<ng-content></ng-content>
